import React from "react";

import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client";
import { QueryClientProvider } from "@tanstack/react-query";

import { ThemeProvider } from "@olist/design-system";
import { ApplicationHost } from "@olist/microfrontend";

import { PublicRouter, routes } from "./routes";
import { GlobalStyle } from "./styles/global";
import { initMockServer } from "./utils";
import { PageLayout } from "components/page-layout";
import { MixpanelProvider } from "contexts";
import { queryClient } from "utils/react-query";

initMockServer();

const client = new ApolloClient({
  uri: "https://internal-wiki.olist.com/graphql",
  cache: new InMemoryCache(),
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_WIKI_TOKEN}`,
    origin: "https://internal-wiki.olist.com",
    dnt: "1",
  },
});

export function App() {
  const legacyHosts = [
    "ajuda.tiny.com.br",
    "suporte.tiny.com.br",
    "suporte.olist.com",
  ];
  const redirectHost = "https://ajuda.olist.com";

  if (legacyHosts.includes(window.location.hostname)) {
    const newUrl = new URL(window.location.href);
    newUrl.hostname = new URL(redirectHost).hostname;

    window.location.href = newUrl.toString();
    return null;
  }
  const isPrivate = window.location.pathname.startsWith("/support");
  const { hostname } = window.location;

  return (
    <ThemeProvider>
      <MixpanelProvider>
        <ApolloProvider client={client}>
          <QueryClientProvider client={queryClient}>
            <GlobalStyle />
            {isPrivate ? (
              <ApplicationHost
                routes={routes}
                ApplicationLayout={PageLayout}
                expectedHostname={hostname}
              />
            ) : (
              <PublicRouter />
            )}
          </QueryClientProvider>
        </ApolloProvider>
      </MixpanelProvider>
    </ThemeProvider>
  );
}
